import { colors } from '../../colors';
var richText = {
  backgroundColor: colors.white,
  h1Color: colors.graphite,
  h2Color: colors.graphite,
  paraColor: colors.graphite,
  anchorColor: colors.petsuitesPurple
};
export default richText;